import React, { useRef, useEffect } from 'react';

import stringToColour from '../../utils/stringToColor';
import formatSeconds from '../../utils/formatSeconds';

import styles from './Display.module.scss';

const Game = ({
  players,
  projectiles,
  projectileSize,
  playerSize,
  remainingTime,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      projectiles.current.forEach((projectile) => {
        if (projectile) {
          ctx.fillStyle = stringToColour(projectile.uid);
          ctx.lineWidth = 1;
          ctx.strokeStyle = 'white';
          ctx.save();
          const size = canvas.width * playerSize;

          ctx.beginPath();

          ctx.translate(
            projectile.x * canvas.width + size / 2,
            projectile.y * canvas.width + size / 2
          );
          ctx.rotate(projectile.d * (Math.PI * 2) + Math.PI / 2);
          ctx.translate(
            -(projectile.x * canvas.width + size / 2),
            -(projectile.y * canvas.width + size / 2)
          );

          ctx.moveTo(projectile.x * canvas.width, projectile.y * canvas.width);
          ctx.lineTo(
            (projectile.x - (projectileSize * projectile.size) / 2) *
              canvas.width,
            (projectile.y + (projectileSize * projectile.size) / 1) *
              canvas.width
          );
          ctx.lineTo(
            (projectile.x + (projectileSize * projectile.size) / 2) *
              canvas.width,
            (projectile.y + (projectileSize * projectile.size) / 1) *
              canvas.width
          );
          ctx.lineTo(projectile.x * canvas.width, projectile.y * canvas.width);
          ctx.stroke();

          ctx.fill();
          ctx.restore();
        }
      });

      players.forEach((player) => {
        if (player.hp > 0) {
          ctx.fillStyle = stringToColour(player.uid);
          ctx.lineWidth = 6;
          ctx.strokeStyle = 'white';

          ctx.save();
          const size = canvas.width * playerSize;

          ctx.beginPath();

          ctx.translate(
            player.x * canvas.width + size / 2,
            player.y * canvas.width + size / 2
          );
          ctx.rotate(player.d * (Math.PI * 2) + Math.PI / 2);
          ctx.translate(
            -(player.x * canvas.width + size / 2),
            -(player.y * canvas.width + size / 2)
          );

          ctx.moveTo(player.x * canvas.width, player.y * canvas.width);
          ctx.lineTo(
            (player.x - playerSize / 2) * canvas.width,
            (player.y + playerSize / 1) * canvas.width
          );
          ctx.lineTo(
            player.x * canvas.width,
            (player.y + playerSize / 1.2) * canvas.width
          );
          ctx.lineTo(
            (player.x + playerSize / 2) * canvas.width,
            (player.y + playerSize / 1) * canvas.width
          );

          ctx.lineTo(player.x * canvas.width, player.y * canvas.width);
          ctx.stroke();

          ctx.fill();

          /*
          ctx.fillRect(
            player.x * canvas.width - size / 2,
            player.y * canvas.height - size / 2,
            size,
            size
          );
          */
          ctx.restore();
        }
      });
    }
  }, [projectiles, players, playerSize, projectileSize]);

  const statusList = players.map((player) => {
    return (
      <div key={player.uid} className={styles.player}>
        <div
          className={styles.indicator}
          style={{ backgroundColor: stringToColour(player.uid) }}
        />
        <div className={styles.name}>{player.name}</div>
        <div className={styles.score}>{player.score}</div>
      </div>
    );
  });

  return (
    <div className={styles.game}>
      <div className={styles.clock}>{formatSeconds(remainingTime)}</div>
      <div className={styles.players}>{statusList}</div>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default Game;
